"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ifftDocs = void 0;
var ifftDocs = exports.ifftDocs = {
  name: 'ifft',
  category: 'Matrix',
  syntax: ['ifft(x)'],
  description: 'Calculate N-dimensional inverse fourier transform',
  examples: ['ifft([[2, 2], [0, 0]])'],
  seealso: ['fft']
};